module.exports = __webpack_public_path__ + "img/millie.a139d96f.png";